module.exports = __webpack_public_path__ + "img/land_02.7e0115f8.jpg";